
/**
 * 获取默认风控数据
 * 所有渠道风控数据无法获取时使用默认值''
 */
export const formatDefaultRcExt = (ext: any) => {
  for (const key in ext) {
    const value = ext[key]
    let result
    if (value === null || value === undefined) {
      result = ''
    } else if (typeof value === 'number' && isNaN(value)) {
      result = ''
    } else {
      result = value
    }
    ext[key] = result
  }
  return ext
}